import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-download-app',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="download-app-section">
      <div class="container">
        <div class="download-content">
          <div class="download-text">
            <h2 class="section-title">Téléchargez notre application</h2>
            <p class="section-description">
              Rejoignez la communauté Zero Waste et gérez vos déchets de manière
              intelligente, où que vous soyez.
            </p>
            <div class="download-buttons">
              <a
                href="https://apps.apple.com/us/app/zero-waste/id6749467802"
                target="_blank"
                class="download-btn app-store-btn"
                aria-label="Télécharger sur l'App Store"
              >
                <img
                  src="assets/images/appStore.png"
                  alt="Télécharger sur l'App Store"
                  class="store-badge"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.zeroWaste&hl=fr"
                target="_blank"
                class="download-btn google-play-btn"
                aria-label="Disponible sur Google Play"
              >
                <img
                  src="assets/images/playConsole.png"
                  alt="Disponible sur Google Play"
                  class="store-badge"
                />
              </a>
            </div>
          </div>
          <div class="download-visual">
            <div class="phone-mockup">
              <img
                src="assets/images/mockup.png"
                alt="Aperçu de l'application Zero Waste"
                class="app-preview"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .download-app-section {
        padding: 80px 0;
        background: #f5f0e1;
        color: black;
        position: relative;
        overflow: hidden;
      }

      .download-app-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(0,0,0,0.05)"/><circle cx="75" cy="75" r="1" fill="rgba(0,0,0,0.05)"/><circle cx="50" cy="10" r="0.5" fill="rgba(0,0,0,0.03)"/><circle cx="10" cy="60" r="0.5" fill="rgba(0,0,0,0.03)"/><circle cx="90" cy="40" r="0.5" fill="rgba(0,0,0,0.03)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
        opacity: 0.3;
      }

      .download-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
        align-items: center;
        position: relative;
        z-index: 1;
      }

      .section-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 20px;
        color: black;
      }

      .section-description {
        font-size: 1.2rem;
        line-height: 1.6;
        margin-bottom: 40px;
        color: black;
        opacity: 0.8;
      }

      .download-buttons {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
      }

      .download-btn {
        display: inline-block;
        transition:
          transform 0.3s ease,
          box-shadow 0.3s ease;
        border-radius: 8px;
        overflow: hidden;
      }

      .download-btn:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
      }

      .store-badge {
        height: 60px;
        width: auto;
        display: block;
      }

      .download-visual {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .phone-mockup {
        position: relative;
        width: 300px;
        height: 600px;
        background: linear-gradient(145deg, #2c3e50, #34495e);
        border-radius: 40px;
        padding: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        transform: perspective(1000px) rotateY(-15deg) rotateX(5deg);
        transition: transform 0.3s ease;
      }

      .phone-mockup:hover {
        transform: perspective(1000px) rotateY(-10deg) rotateX(2deg);
      }

      .phone-mockup::before {
        content: '';
        position: absolute;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 4px;
        background: #34495e;
        border-radius: 2px;
      }

      .app-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .download-content {
          grid-template-columns: 1fr;
          gap: 40px;
          text-align: center;
        }

        .section-title {
          font-size: 2rem;
        }

        .section-description {
          font-size: 1.1rem;
        }

        .download-buttons {
          justify-content: center;
        }

        .store-badge {
          height: 50px;
        }

        .phone-mockup {
          width: 250px;
          height: 500px;
          transform: none;
        }

        .phone-mockup:hover {
          transform: scale(1.05);
        }
      }

      @media (max-width: 480px) {
        .download-app-section {
          padding: 60px 0;
        }

        .download-buttons {
          flex-direction: column;
          align-items: center;
        }

        .store-badge {
          height: 45px;
        }

        .phone-mockup {
          width: 200px;
          height: 400px;
        }
      }

      /* Animation pour l'apparition */
      .download-content {
        animation: fadeInUp 0.8s ease-out;
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
  ],
})
export class DownloadAppComponent {}
